// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__18U-3","empty":"ModalGraph_empty__1W8_2"};